// Seems reasonable that artists/creators won't want to have 10000 editions.
// Can always adjust this later.
const MAX_EDITION_SUPPLY = 10000;

export default MAX_EDITION_SUPPLY;
